import { colors } from '../constants/colors.js';

var searchThemeWeb = {
  closeIconColor: colors.inkGrey
};
var searchDarkThemeWeb = {
  closeIconColor: colors.cloudGrey
};

export { searchDarkThemeWeb, searchThemeWeb };
